<template>
  <form>
    <v-text-field
      v-model="name"
      :error-messages="nameErrors"
      :counter="50"
      :label="$t('enterprises.name')"
      required
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
    />
    <div
      class="text-right pt-2"
    >
      <v-btn v-if="!isNew" color="red darken-1" dark class="mr-4" @click="showConfirmDelete = !showConfirmDelete">{{ $t('common.delete') }}</v-btn>
      <v-btn class="mr-4" @click="handleClear">{{ $t('common.cancel') }}</v-btn>
      <v-btn dark :color="enterpriseColor" @click="handleSubmit">{{ $t('common.save') }}</v-btn>
    </div>
    <confirm-delete 
      :showDialog="showConfirmDelete"
      :onKO="handleCancelDelete"
      :onOK="handleDelete"
    />
  </form>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, maxLength } from 'vuelidate/lib/validators'
  import ConfirmDelete from '@/components/ConfirmDelete'

  export default {
    mixins: [validationMixin],
    components: {
      ConfirmDelete
    },
    props: {
      data: {
        type: Object,
        required: false,
        default: null
      },
      onDelete: {
        type: Function,
        required: true
      },
      onSave: {
        type: Function,
        required: true
      },
      onCancel: {
        type: Function,
        required: true
      },
      onClearStats: {
        type: Function,
        required: true
      },
    },
    data: () => ({
      name: '',
      showConfirmDelete: false,
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      isNew () {
        return this.$route.params.id === 'new'
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push(this.$t('enterprises.messages.nameMostCharacters'))
        !this.$v.name.required && errors.push(this.$t('enterprises.messages.nameRequired'))
        return errors
      },
    },
    watch: {
      'data.Name' (v) {
        if (v) this.name = v
      },
    },
    validations() { 
      return {
        name: { required, maxLength: maxLength(50) },
      }
    },
    mounted () {
      this.name = this.data && this.data.Name ? this.data.Name : ''
    },
    methods: {
      handleSubmit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          const body = {
            Name: this.name,
          }
          this.onSave(body)
        }

      },
      handleCancelDelete() {
        this.showConfirmDelete = false
      },
      handleDelete () {
        this.showConfirmDelete = false
        this.onDelete()
      },
      handleClear () {
        this.$v.$reset()
        this.name = ''
        this.onCancel()
      }
    },
  }
</script>
